import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* ============================================================
   เลื่อนหน้าจอเมื่อเปลี่ยน route / มี hash anchor (#section)
   ============================================================ */
export default function HashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        return false;
      };
      if (!scroll()) setTimeout(scroll, 350);
    } else {
      window.scrollTo({ top: 0, left: 0 });
    }
  }, [pathname, hash]);

  return null;
}
